import React from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";

// import About from "./components/About";
// import Contact from "./components/Contact";
// import Projects from "./components/Projects";
// import Skills from "./components/Skills";
// import Plays from "./components/Plays";
// import CodingJourney from "./components/codingJourney";
import {
  BrowserRouter as Router,
  HashRouter,
  Routes,
  Route,
} from "react-router-dom";
import CodingJourney from "./pages/CodingJourneyPage";
import BlogsPage from "./pages/BlogsPage";
import Works from "./pages/Works";
import Plays from "./pages/Plays";
import Architecture from "./pages/Architecture";
import ProductDesign from "./pages/ProductDesign";
import Developer from "./pages/Developer";

export default function App() {
  return (
    <main className="text-gray-400  bg-gray-900  body-font">
      {/* <Router> */}
    <HashRouter>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/Architecture" element={<Architecture />} />
        <Route exact path="/ProductDesign" element={<ProductDesign />} />
        <Route exact path="/Developer" element={<Developer />} />
        <Route exact path="/Works" element={<Works />} />
        <Route exact path="/Plays" element={<Plays />} />
        <Route exact path="/BlogsPage" element={<BlogsPage />} />
        <Route exact path="/CodingJourney" element={<CodingJourney />} />
      </Routes>
    </HashRouter>
      {/* </Router> */}
    </main>
  );
}
